import React from "react";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";

const FeeList = ({ fees }) => {
  const { t } = useTranslation("feePage");

  if (!fees) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (fees.length === 0) {
    return <Alert severity="warning">{t("table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1280"
        size="14"
      >
        <StyledTableHead
          scroll="auto"
          col="8"
        >
          <div>
            {t("table.service")}
          </div>
          <div>
            {t("table.paymentSystem")}
          </div>
          <div>
            {t("table.currency")}
          </div>
          <div>
            {t("table.type")}
          </div>
          <div>
            {t("table.percent")}
          </div>
          <div>
            {t("table.constant")}
          </div>
          <div>
            {t("table.min")}
          </div>
          <div>
            {t("table.max")}
          </div>
          <div />
        </StyledTableHead>
        <StyledTableBody>
          {fees && fees.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="8"
            >
              <StyledCol>
                {value.baseFee.service.name}
              </StyledCol>
              <StyledCol>
                {value.baseFee.paymentSystem.name}
              </StyledCol>
              <StyledCol>
                {value.baseFee.currency.asset}
              </StyledCol>
              <StyledCol>
                {value.baseFee.type}
              </StyledCol>
              <StyledCol>
                {Math.round((value.percent * 100) * 1000) / 1000} %
              </StyledCol>
              <StyledCol>
                {value.constant}
              </StyledCol>
              <StyledCol>
                {value.min}
              </StyledCol>
              <StyledCol>
                {value.max}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default FeeList;